import(/* webpackMode: "eager" */ "/var/www/eduegoo/frontend/app/global-error.tsx");
